import { Injectable } from '@angular/core';
import { JeevesCustomerActionConfigService, JeevesModalService } from 'gung-standard-jeeves';
import {
  ActivityInternalCreateModalComponent,
  AuthService,
  Customer,
  gungAddRemoveSpinner,
  GungModalService,
  NavbarConfigService,
  ReportCentralReportService,
  SelectedCustomerService
} from 'gung-standard';
import { ActionButton } from 'gung-common';
import { first, map, switchMap } from 'rxjs';
import { Router } from '@angular/router';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { Observable, of } from 'rxjs';
import { ColmecModalService } from './colmec-modal.service';
import { ColmecJeevesModalService } from './colmec-jeeves-modal.service';
import { TranslateService } from '@ngx-translate/core';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class ColmecCustomerActionConfigService extends JeevesCustomerActionConfigService {
  base = [
    {
      title: 'ADD_CONTACT',
      action: (item: Customer) => {
        this.gungModalService.openAddContactModal(item);
      }
    },
    {
      title: 'PLACE_ORDER',
      action: (item2: Customer) => {
        this.selectedCustomerService.selectCustomer(item2.id);
        this.authService
          .getCurrentUser()
          .pipe(first())
          .subscribe(user => {
            this.router.navigate(['categories/s100']);
          });
      }
    },
    {
      title: 'EDIT_CUSTOMER',
      action: (item: Customer) => {
        this.modalService.openEditCustomerModal(item);
      }
    },
    {
      title: 'ACTIVITY_CREATE',
      action: (customer: Customer) => {
        this.colmecModalService.openCreateActivityModal().then(
          result => {},
          reason => {
            console.log(`Dismissed ${reason}`);
          }
        );
      }
    },
    {
      title: 'ACTIVITIES',
      action: (item2: Customer) => {
        this.authService
          .getCurrentUser()
          .pipe(first())
          .subscribe(user => {
            this.router.navigate(['activity-internal']);
          });
      }
    }
  ];
  isAdmin = false;
  constructor(
    protected modalService: ColmecJeevesModalService,
    protected authService: AuthService,
    protected router: Router,
    protected selectedCustomerService: SelectedCustomerService,
    protected ngbModal: NgbModal,
    private colmecModalService: ColmecModalService,
    protected translateService: TranslateService,
    gungModalService: GungModalService,
    navbarConfigService: NavbarConfigService,
    protected reportCentralReportService: ReportCentralReportService
  ) {
    super(modalService, authService, router, selectedCustomerService, ngbModal, gungModalService, navbarConfigService, reportCentralReportService);
    if (environment?.enableClaim) {
      this.base.push({
        title: 'CREATE_CLAIM',
        action: (customer: Customer) => {
          const target = event.target as HTMLElement;
          gungAddRemoveSpinner(target);
          this.colmecModalService
            .openClaimModal(customer)
            .then(
              answer => {
                console.log('answer', answer);
                if (answer) {
                  const rmanr =
                    answer['#result-set-1'] && answer['#result-set-1'].length > 0 && answer['#result-set-1'][0][''];
                  this.colmecModalService
                    .openConfirmYesNoModal(
                      null,
                      this.translateService.instant('CLAIM_CREATED_SUCCESS', { id: rmanr || '' }),
                      null,
                      'OK',
                      null
                    )
                    .then(_ => {});
                  gungAddRemoveSpinner(target);
                } else {
                  gungAddRemoveSpinner(target);
                  // this.colmecModalService.openConfirmYesNoModal(undefined, 'ERROR', { size: 'sm' }, 'OK', null).then(_ => { });
                }
              },
              error => {
                gungAddRemoveSpinner(target);
                // this.colmecModalService.openConfirmYesNoModal(undefined, 'ERROR', { size: 'sm' }, 'OK', null).then(_ => { });
              }
            )
            .catch(res => gungAddRemoveSpinner(target));
        }
      });
      this.base.push({
        title: 'CLAIMS',
        action: (item2: Customer) => {
          this.authService
            .getCurrentUser()
            .pipe(first())
            .subscribe(user => {
              this.router.navigate(['claims']);
            });
        }
      });
    }
    this.authService
      .getRoles()
      .pipe(first())
      .subscribe(roles => {
        this.isAdmin = roles.filter(role => role.toUpperCase() === 'ADMIN').length > 0;
        if (this.isAdmin) {
          this.base.push({
            title: 'CREATE_USER',
            action: (item: Customer) => {
              this.createUser(item);
            }
          });
        }
      });
  }
}
